import { apiClient } from 'api';
// ../../../api

export type LoginDTO = {
  userName: string;
  password: string;
};

export type LoginResponse = {
  name? : string ;
  email? : string ;
  token: string;
  refreshToken: string;
  type:string;
 
};

export interface LoginResponseData {
  userId: string;
  name: string;
  email: string;
  token: string;
  refreshToken: string;
}

export interface BaseResponse<T> {
  rs: number;
  res: T;
  rc?: any[]; // if this is always an array, or refine as needed
  msgkey?: string | null;
  ukey?: string;
  customMessage?: string;
  itemId?: number;
  totalRecords?: number;
}
     
export type RefreshTokenDTO = {
  grant_type: 'refresh_token';
  token: string;
};

export const AuthApiService = () => {
  const login = async (payload: LoginDTO) => {
    const response = await apiClient<BaseResponse<LoginResponseData>>({
      endpoint: '/Auth/Login',
      method: 'POST',
      data: payload,
      config: {
        skipAuthRefresh: true,
      },
    });
    
    
    return response.data;
  };

  const refreshToken = async (payload: RefreshTokenDTO) => {
    const response = await apiClient<LoginResponse>({
      endpoint: '/admin/login/refresh',
      method: 'POST',
      data: payload,
      config: {
        skipAuthRefresh: true,
      },
    });

    return response.data;
  };

  return {
    login,
    refreshToken,
  };
};
